"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _useRecommendationHeader = require("../../hooks/recommendation/useRecommendationHeader");
var _BaseComponents = require("../StyledComponents/BaseComponents");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var LightBackgroundDiv = (0, _BaseComponents.LightBackground)('div');
var RecommendationHeader = function RecommendationHeader() {
  var _useRecommendationHea = (0, _useRecommendationHeader.useRecommendationHeader)(),
    headerText = _useRecommendationHea.headerText;
  return /*#__PURE__*/_react.default.createElement(LightBackgroundDiv, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6,
      bottom: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    layout: {
      sm: [8],
      md: [5],
      lg: [6]
    },
    justify: 'center'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    appearance: "secondary",
    size: 2,
    justify: 'center',
    weight: 3,
    text: headerText,
    noMargin: true
  }))));
};
var _default = RecommendationHeader;
exports.default = _default;